/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { postData } from '@jda/lui-portal-utilities';

import { getAuthDetailsAction, getAuthPolicyDetailsAction } from './authActionCreator';
import { IAuthorization } from '../../models/Authorization/IAuthorization';
import { createRequestObject, getUserTokenData, getAPIMUrl } from '../../utility/commonUtility';
import { hideAppLoader, showAppLoader } from '../appLoader/appLoader';

const { CLIENT_SERVICE_V1_URL } = window['env'];

const reqObj = [
  {
    "namespace": "by.iam",
    "resources": [
      {
        "resource": "realm_entities",
        "data": [{ "*": "*" }]
      },
      {
        "resource": "password_policy",
        "data": [{ "*": "*" }]
      },
      {
        "resource": "locations",
        "data": [{ "*": "*" }]
      },
      {
        "resource": "roles",
        "data": [{ "*": "*" }]
      },
      {
        "resource": "idp",
        "data": [{ "*": "*" }]
      },
      {
        "resource": "groups",
        "data": [{ "*": "*" }]
      },
      {
        "resource": "groups_subjects",
        "data": [{ "*": "*" }]
      },
      {
        "resource": "groups_roles",
        "data": [{ "*": "*" }]
      },
      {
        "resource": "mfa",
        "data": [{ "*": "*" }]
      }
    ],
    "checks": {
      "entityPermissions": true,
      "attributePermissions": false,
      "dataPermissions": true
    }
  }
];

export async function getAuthDetails(dispatch: Function, locationName?: string) {
  dispatch(showAppLoader);

  try {
    const subjectId: { sub: string } = await getUserTokenData();
    const BASE_APIM_URL = await getAPIMUrl();
    const permissionsData = await postData<IAuthorization>(
      createRequestObject(`${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/subjects/${subjectId.sub}/searchPermissions`),
      { permissionFilters: ['*'] },
      locationName
        ? {
          headers: {
            'LOCATION-CONTEXT': locationName
          }
        }
        : undefined
    );
    dispatch(hideAppLoader);
    const permissionsResponse: IAuthorization = {
      permissions: permissionsData.permissions
    };

    dispatch(getAuthDetailsAction(permissionsResponse));
  } catch (error: any) {
    dispatch(hideAppLoader);
    dispatch(getAuthDetailsAction({ permissions: [] }));
  }
}

export async function getAuthPolicyDetails(dispatch: Function, locationName?: string) {
  dispatch(showAppLoader);
  try {
    const subjectId: { sub: string } = await getUserTokenData();
    const BASE_APIM_URL = await getAPIMUrl();
    const resourcePermissionsData = await postData<any>(
      createRequestObject(`${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/subjects/${subjectId.sub}/resourcePermissions`),
      reqObj,
      locationName
        ? {
          headers: {
            'LOCATION-CONTEXT': locationName
          }
        }
        : undefined
    );

    const resources: { [key: string]: any } = {};
    resourcePermissionsData[0]?.resources?.forEach((item: any) => item?.resource && (resources[item.resource] = item));
    const assignedPermissions = {
      ...resourcePermissionsData[0],
      resources
    };

    dispatch(hideAppLoader);


    dispatch(getAuthPolicyDetailsAction(assignedPermissions));
  } catch (error: any) {
    dispatch(hideAppLoader);
    dispatch(getAuthPolicyDetailsAction({ resources: [] }));
  }
}